import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Tabs from '../../../components/common/Tabs';
import Loading from '../../../components/common/Loading';
import VacancyForm from '../../../components/module/rec/vacancy/VacancyForm';
import VacancyJDForm from '../../../components/module/rec/vacancy/VacancyJDForm';
import VacancyUploadForm from '../../../components/module/rec/vacancy/VacancyUploadForm';
import api from '../../../utils/api';

const EditVacancy: React.FC = () => {
  const [tabs, setTabs] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState<any>();

  useEffect(() => {
    const fetchTabs = async () => {
      try {
        setIsLoading(true);
        const response = await api<{ data: any[] }>({
          method: 'GET',
          url: `/cmn/menu/tab/${10}`,
        });
        setActiveTab(response.data.data[0].menuId);
        setTabs((response.data.data ?? []).map((tab) => ({ label: tab.name, value: tab.menuId })));
      } catch (error) {
        console.error('Error fetching tabs:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTabs();
  }, []);

  const handleTabChange = (value: string) => {
    setActiveTab(value);
  };

  const renderContent = () => {
    switch (activeTab) {
      case tabs[0]?.value:
        return <VacancyForm type="edit" onCancel={() => { }} onSave={() => { }} />;
      case tabs[1]?.value:
        return <VacancyJDForm type="edit" onCancel={() => { }} onSave={() => { }} />;
      case tabs[2]?.value:
        return <VacancyUploadForm type="edit" onCancel={() => { }} onSave={() => { }} />;
      default:
        return null;
    }
  };

  return (
    <Box className="page-container" p={3}>
      {isLoading ? (
        <Loading />
      ) : (
        <>
            <Typography className="page-title" mb={3}>
              Edit Vacancy
            </Typography>
            <Box mb={3}>
              <Tabs
                tabs={tabs}
                value={activeTab}
                onChange={handleTabChange}
              />
            </Box>
            {renderContent()}
        </>
      )}
    </Box>
  );
};

export default EditVacancy; 
